import { PropsWithChildren } from 'react';

const FormLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className="p-mt-3">{children}</div>;
};

export default FormLayout;
